/**
 * NDAKUBET i18n setup — Iter 106.
 *
 * Languages: English (default), French, Spanish, Lingala.
 *  - en: canonical, hand-written.
 *  - fr / es: hand-written by humans.
 *  - ln: bootstrapped via Claude Sonnet 4.5 (see /app/backend/translate_locale.py).
 *
 * Storage of selected language:
 *  - localStorage (`ndaku_lang`) for anonymous users + immediate UX.
 *  - DB-synced via PATCH /api/me/language for authenticated users
 *    (handled by AuthContext on login + LanguageSwitcher on change).
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "../locales/en.json";
import fr from "../locales/fr.json";
import es from "../locales/es.json";
import ln from "../locales/ln.json";

export const SUPPORTED_LANGS = [
  { code: "en", labelKey: "language.english", flag: "🇬🇧" },
  { code: "fr", labelKey: "language.french", flag: "🇫🇷" },
  { code: "es", labelKey: "language.spanish", flag: "🇪🇸" },
  { code: "ln", labelKey: "language.lingala", flag: "🇨🇩" },
];
const SUPPORTED_CODES = SUPPORTED_LANGS.map((l) => l.code);

export const LANG_STORAGE_KEY = "ndaku_lang";

const _initialLang = (() => {
  try {
    const saved = localStorage.getItem(LANG_STORAGE_KEY);
    if (saved && SUPPORTED_CODES.includes(saved)) return saved;
  } catch {}
  return "en"; // user requested: always English by default for first-time visitors
})();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      es: { translation: es },
      ln: { translation: ln },
    },
    lng: _initialLang,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    returnNull: false,
    returnEmptyString: false,
  });

/** Update language in i18next + localStorage in one call. */
export const setAppLanguage = (code) => {
  if (!SUPPORTED_CODES.includes(code)) return;
  i18n.changeLanguage(code);
  try { localStorage.setItem(LANG_STORAGE_KEY, code); } catch {}
};

export default i18n;
